import { ImageHelpers } from 'helpers/images';
import WCCAttachment from 'models/attachments/attachment';
import WccImage from 'models/attachments/image';
import pattern from 'patterns/photoset';
import itemPattern from 'patterns/photosetItem';
import { WCCContentAttachmentsBlock } from '../blocks/attachments/attachments';
import WCCContentPatternRule from './pattern';

export default class WCCContentPhotosetRule extends WCCContentPatternRule {
    protected pattern = pattern;

    protected process(match: RegExpMatchArray) {
        const data = _(this.parseContent(match[1])).defaults({
            rowsCount: 0,
            expand: false
        });

        const attachments = ko.pureComputed(() => _(data.items).map(item => this.getImage(item)));

        return new WCCContentAttachmentsBlock({
            content: match[0],
            attachments: attachments,
            rowsCount: data.rowsCount,
            expand: data.expand
        });
    };

    private parseContent(content: string) {
        if (content[0] === '{' && content[content.length - 1] === '}')
            return this.parseJSON(content);

        return this.parseItemsString(content);
    }

    private parseJSON(content: string) {
        return JSON.parse(content);
    }

    private parseItemsString(content: string) {
        const items = content.split(';').map(str => this.getItem(str));

        return { items };
    }

    private decode(str: string) {
        return decodeURI(decodeURI(str));
    }

    private getItem(str: string) {
        str = this.decode(str.toLowerCase());

        const match = itemPattern.exec(str);

        if (match != undefined)
            return { url: match[1] || '', title: match[2] || '' }

        return { url: str, title: '' }
    }

    private getImage(item: any): WCCAttachment {
        const wccImage = new WccImage({
            Link: item.url,
            Title: item.title,
            FileType: enums.AttachmentTypes.Image.value
        });

        ImageHelpers.waitImage(ImageHelpers.getImage(item.url, true)).then(image => {
            wccImage.width(image.width);
            wccImage.height(image.height);
        });

        return wccImage;
    };
}